export const GOAL_TONE = { achieved: "success", partial: "warning", failed: "error", not_decidable: "neutral" };
export const CLAIM_TONE = { supported: "success", contradicted: "error", unsupported: "warning" };

export const fmtRate = (v) => (v == null ? "—" : `${Math.round(v * 100)}%`);
export const fmtTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—";
